import { createContext, useState } from "react";

export const MainContext = createContext();

const ContextProvider = ({ children }) => {
  const [Sections] = useState([
    {
      title: "Description",
      topics: [
        "Private law",
        "Key Features of Private Law",
        "The challenges and complexities of private law",
        "Accurate strategies and legal advice",
      ],
    },
    { title: "Problems and challenges", topics: [] },
    { title: "AI lawyer is with you", topics: [] },
    { title: "How to use", topics: [] },
    { title: "Security and privacy features", topics: [] },
    { title: "Resources", topics: [] },
  ]);
  return <MainContext.Provider value={{Sections}}>{children}</MainContext.Provider>;
};

export default ContextProvider;
